var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"groupTree",style:({
    width: _vm.$vuetify.breakpoint.mdAndUp ? '1000px' : '',
    margin: _vm.$vuetify.breakpoint.mdAndUp ? '0 auto' : '',
  }),attrs:{"column":"","wrap":""}},[_c('draggable',{attrs:{"handle":".draghandle"},model:{value:(_vm.groups),callback:function ($$v) {_vm.groups=$$v},expression:"groups"}},_vm._l((_vm.items),function(item){return _c('groups-tree-item',{key:item.slug,attrs:{"item":item,"depth":0}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }